import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setActiveTab } from "../../../store/activeTabSlice";

import { EnterprisePanel } from "../../../components/admin/u1/enterprise/EnterprisePanel";
import { PartnerProgramGate } from "../../../components/admin/u1/enterprise/PartnerProgramGate";
import { canUsePartnerProgram } from "../../../components/admin/u1/enterprise/enterpriseIdentity";
import { selectActiveCompany } from "../../../store/activeCompanySlice";
import "../../../components/common/u1/tokens.css";

/* u1 Partner Program (the Enterprise screen). */
export default function Enterprise() {
  const activeCompany = useSelector(selectActiveCompany);
  const dispatch = useDispatch();
  const allowed = canUsePartnerProgram(activeCompany);

  /* DashboardTopbar titles the page from the rail item whose route matches, and falls back to the activeTab slice when there is none. */
  useEffect(() => {
    if (!allowed) dispatch(setActiveTab("Partner Program"));
  }, [allowed, dispatch]);

  if (!allowed) {
    return (
      <div className="u1-root min-w-0 py-6">
        <PartnerProgramGate
          companyName={activeCompany?.registered_company_name || activeCompany?.name || ""}
        />
      </div>
    );
  }

  return (
    <div className="u1-root min-w-0 py-6">
      <EnterprisePanel />
    </div>
  );
}
